import React, { useState, useEffect, lazy } from "react";
import { Layout, Page, Text } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

import { LineChart } from "@shopify/polaris-viz";
import CardGraph from "./CardGraph";

import CardList from "./CardList";

import '@shopify/polaris-viz/build/esm/styles.css';

const SearchHeatmap = lazy(() => import("./SearchHeatmap.jsx"));

export default function AnalyticsIndex(props) {
  const { t } = useTranslation();
  const [timePeriod, setTimePeriod] = useState("last7days");
  const [compareToPrevious, setCompareToPrevious] = useState(false);

  const timePeriodOptions = [
    // { value: "today", label: t("analytics.timePeriods.today") },
    // { value: "yesterday", label: t("analytics.timePeriods.yesterday") },
    { value: "last7days", label: t("analytics.timePeriods.last7days") },
    { value: "last30days", label: t("analytics.timePeriods.last30days") },
    // { value: "weektodate", label: t("analytics.timePeriods.weekToDate") },
    // { value: "monthtodate", label: t("analytics.timePeriods.monthToDate") },
  ];

  const dashboardParams = {
    period: timePeriod,
    compare_to_previous: compareToPrevious,
  };

  const compareToPreviousAction = compareToPrevious
    ? {
        content: t("analytics.comparison.stopComparing"),
        onAction: () => setCompareToPrevious(false),
      }
    : {
        content: t("analytics.comparison.compareToPrevious"),
        onAction: () => setCompareToPrevious(true),
      };

  const timeSelectorActionGroup = {
    title: timePeriodOptions.find((tp) => tp.value == timePeriod).label,
    actions: timePeriodOptions.map((tp) => {
      return {
        content: tp.label,
        onAction: () => setTimePeriod(tp.value),
      };
    }),
  };

  return (
    <Page fullWidth>
      <TitleBar
        title={t("analytics.title")}
        breadcrumbs={[]}
        secondaryActions={[compareToPreviousAction]}
        actionGroups={[timeSelectorActionGroup]}
      />
      <Layout>
        <Layout.Section fullWidth>
          <div style={{ marginBottom: "0.5rem" }}>
            <Text variant="headingMd" as="h2">{t("analytics.sections.searchLocations")}</Text>
          </div>

          <SearchHeatmap
            url="/reports/map_searches"
            dataKey="mapSearches"
            dashboardParams={dashboardParams}
            height={"450px"}
          />
        </Layout.Section>
        <Layout.Section oneThird>
          <CardGraph
            title={t("analytics.cards.sessions")}
            chart={LineChart}
            height="300px"
            url="/reports/sessions"
            dataKey="sessions"
            dashboardParams={dashboardParams}
          />
          <CardList
            title={t("analytics.cards.topSearches")}
            limit={5}
            height="300px"
            url={"/reports/top_searches"}
            dataKey="topSearches"
            dashboardParams={dashboardParams}
          />
          <CardList
            title={t("analytics.cards.topLandingPageType")}
            limit={5}
            height="250px"
            url={"/reports/top_landing_page_type"}
            dataKey="topLandingPageType"
            dashboardParams={dashboardParams}
          />
        </Layout.Section>
        <Layout.Section oneThird>
          <CardList
            title={t("analytics.cards.topPageViewsBySession")}
            limit={10}
            height="300px"
            url={"/reports/top_sessions"}
            dataKey="topSessions"
            dashboardParams={dashboardParams}
          />
          <CardList
            title={t("analytics.cards.topLocations")}
            limit={10}
            height="300px"
            url={"/reports/top_locations"}
            dataKey="topLocations"
            dashboardParams={dashboardParams}
          />
          <CardList
            title={t("analytics.cards.topReferrers")}
            limit={5}
            height="250px"
            url={"/reports/top_landing_page_referrers"}
            dataKey="topLandingPageReferrers"
            dashboardParams={dashboardParams}
          />
        </Layout.Section>
        <Layout.Section oneThird>
          <CardGraph
            title={t("analytics.cards.searches")}
            chart={LineChart}
            url="/reports/searches"
            dataKey="searches"
            dashboardParams={dashboardParams}
            height="300px"
          />
          <CardList
            title={t("analytics.cards.topLandingPagesBySession")}
            limit={5}
            height="300px"
            url={"/reports/top_landing_pages"}
            dataKey="topLandingPages"
            dashboardParams={dashboardParams}
          />
        </Layout.Section>
        <Layout.Section fullWidth></Layout.Section>
        <Layout.Section oneHalf></Layout.Section>
        <Layout.Section fullWidth></Layout.Section>
      </Layout>
    </Page>
  );
}

// const calendarPopover = (
//   <Popover
//     active={calendarActive}
//     preferredPosition="below"
//     preferredAlignment="right"
//     activator={
//       <Button
//         disclosure="down"
//         icon={CalendarMajor}
//         onClick={() => setCalendarActive(!calendarActive)}
//       >
//         {timePeriodLabel}
//       </Button>
//     }
//     autofocusTarget="first-node"
//     onClose={() => setCalendarActive(!calendarActive)}
//   >
//     <Popover.Pane>
//       <OptionList
//         onChange={(tp) => setTimePeriod(tp[0])}
//         options={timePeriodOptions}
//         selected={[timePeriod]}
//       />
//     </Popover.Pane>
//     <Popover.Pane fixed>
//       <Popover.Section>
//         <Checkbox
//           label="Compare to previous period"
//           onChange={setCompareToPrevious}
//           checked={compareToPrevious}
//         />
//       </Popover.Section>
//     </Popover.Pane>
//   </Popover>
// );
